/**
 * Binance C2C REST API
 *
 * OpenAPI Specification for the Binance C2C REST API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ConfigurationRestAPI,
    TimeUnit,
    RestApiResponse,
    sendRequest,
    type RequestArgs,
} from '@binance/common';
import type { GetC2CTradeHistoryResponse } from '../types';

/**
 * C2CApi - axios parameter creator
 */
const C2CApiAxiosParamCreator = function (configuration: ConfigurationRestAPI) {
    return {
        /**
         * Get C2C Trade History
         *
         * The max interval between startTimestamp and endTimestamp is 30 days.
         * If startTimestamp and endTimestamp are not sent, the recent 30 days' data will be returned.
         * You can only view data from the past 6 months. To see all C2C orders, please check https://c2c.binance.com/en/fiatOrder
         *
         * Weight: 1
         *
         * @summary Get C2C Trade History (USER_DATA)
         * @param {string} [tradeType] BUY, SELL
         * @param {number | bigint} [startTimestamp]
         * @param {number | bigint} [endTimestamp]
         * @param {number | bigint} [page] Default 1
         * @param {number | bigint} [rows] default 100, max 100
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getC2CTradeHistory: async (
            tradeType?: string,
            startTimestamp?: number | bigint,
            endTimestamp?: number | bigint,
            page?: number | bigint,
            rows?: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (tradeType !== undefined && tradeType !== null) {
                localVarQueryParameter['tradeType'] = tradeType;
            }
            if (startTimestamp !== undefined && startTimestamp !== null) {
                localVarQueryParameter['startTimestamp'] = startTimestamp;
            }
            if (endTimestamp !== undefined && endTimestamp !== null) {
                localVarQueryParameter['endTimestamp'] = endTimestamp;
            }
            if (page !== undefined && page !== null) {
                localVarQueryParameter['page'] = page;
            }
            if (rows !== undefined && rows !== null) {
                localVarQueryParameter['rows'] = rows;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/c2c/orderMatch/listUserOrderHistory',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
    };
};

/**
 * C2CApi - interface
 * @interface C2CApi
 */
export interface C2CApiInterface {
    /**
     * Get C2C Trade History
     *
     * The max interval between startTimestamp and endTimestamp is 30 days.
     * If startTimestamp and endTimestamp are not sent, the recent 30 days' data will be returned.
     * You can only view data from the past 6 months. To see all C2C orders, please check https://c2c.binance.com/en/fiatOrder
     *
     * Weight: 1
     *
     * @summary Get C2C Trade History (USER_DATA)
     * @param {GetC2CTradeHistoryRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof C2CApiInterface
     */
    getC2CTradeHistory(
        requestParameters?: GetC2CTradeHistoryRequest
    ): Promise<RestApiResponse<GetC2CTradeHistoryResponse>>;
}

/**
 * Request parameters for getC2CTradeHistory operation in C2CApi.
 * @interface GetC2CTradeHistoryRequest
 */
export interface GetC2CTradeHistoryRequest {
    /**
     * BUY, SELL
     * @type {string}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly tradeType?: string;

    /**
     *
     * @type {number | bigint}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly startTimestamp?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly endTimestamp?: number | bigint;

    /**
     * Default 1
     * @type {number | bigint}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly page?: number | bigint;

    /**
     * default 100, max 100
     * @type {number | bigint}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly rows?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly recvWindow?: number | bigint;
}

/**
 * C2CApi - object-oriented interface
 * @class C2CApi
 */
export class C2CApi implements C2CApiInterface {
    private readonly configuration: ConfigurationRestAPI;
    private localVarAxiosParamCreator;

    constructor(configuration: ConfigurationRestAPI) {
        this.configuration = configuration;
        this.localVarAxiosParamCreator = C2CApiAxiosParamCreator(configuration);
    }

    /**
     * Get C2C Trade History
     *
     * The max interval between startTimestamp and endTimestamp is 30 days.
     * If startTimestamp and endTimestamp are not sent, the recent 30 days' data will be returned.
     * You can only view data from the past 6 months. To see all C2C orders, please check https://c2c.binance.com/en/fiatOrder
     *
     * Weight: 1
     *
     * @summary Get C2C Trade History (USER_DATA)
     * @param {GetC2CTradeHistoryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetC2CTradeHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof C2CApi
     * @see {@link https://developers.binance.com/docs/c2c/rest-api/Get-C2C-Trade-History Binance API Documentation}
     */
    public async getC2CTradeHistory(
        requestParameters: GetC2CTradeHistoryRequest = {}
    ): Promise<RestApiResponse<GetC2CTradeHistoryResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.getC2CTradeHistory(
            requestParameters?.tradeType,
            requestParameters?.startTimestamp,
            requestParameters?.endTimestamp,
            requestParameters?.page,
            requestParameters?.rows,
            requestParameters?.recvWindow
        );
        return sendRequest<GetC2CTradeHistoryResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }
}
